if (!customElements.get("collection-showcase")) {
  customElements.define(
    "collection-showcase",
    class CollectionShowcase extends HTMLElement {


      constructor() {
        super();

        const buttons = this.querySelectorAll(".cs-col-buttons-cont button.cs-col-button");
        buttons.forEach(button => {
          button.addEventListener('click', (e) => {
            this.onChangeButton(e.currentTarget);
          })
        })
      }

      onChangeButton(btn) {

        const idx = btn.dataset.cidx * 1;
        const productsContainer = this.querySelectorAll(".cs-col-prod-cont");
        productsContainer.forEach(container => {
          const cidx = container.dataset.cidx * 1;
          if (idx === cidx) {
            container.classList.add("active");
          } else {
            container.classList.remove("active");
          }
        })
        const buttons = this.querySelectorAll(".cs-col-buttons-cont button.cs-col-button");
        buttons.forEach(button => {
          const cidx = button.dataset.cidx * 1;
          if (idx === cidx) {
            button.classList.add("active");
          } else {
            button.classList.remove("active");
          }
        });
      }
    }
  );
}
